module.exports = __webpack_public_path__ + "img/activity-bg.52287100.png";